/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';

import * as angular from 'angular';

angular.module('ticketspaceApp').factory('atomicAssembler', function () {
	function segment(path, obj) {
		let newObj = {};
		newObj[path] = obj;
		return newObj;
	}

	function assemble() {
		let base = {};

		for (let i = 0; i < arguments.length; i++) {
			angular.extend(base, arguments[i]);
		}
		return base;
	}

	return {
		segment,
		assemble,
	};
});
